import React from 'react';
import store from "../../store";
import {getCardlessDetails} from "../../providers/authorizations";
import moment from "moment";
import connect from "react-redux/es/connect/connect";

import {formatAmount} from "../../lib/utils";

const Translate = require('react-redux-i18n').Translate;

const I18n = require('react-redux-i18n').I18n

const stateMap = (store) => {
    return {
        userReducer: store.userReducer
    };
};

const euro = " €";

export class CardlessDetails extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            id: '',
            transactionId: '',
            source: '',
            mid: '',
            amount: '',
            authorizationDate: '',
            authorizationTime: '',
            merchantFee: '',
            merchantCommissionAmount: '',
            acquirerFee: '',
            acquirerCommissionAmount: '',
            closeBatchDate: '',
            paymentDate: '',
            paymentReqDate: '',
            paymentRespDate: '',
            paymentRespMessage: '',
            debitNoteMonth: '',
            debitNoteYear: '',
            debitNoteNumber: '',
            debitNoteScheme: '',
            inserted: '',
        }
        this.getCardlessDetails = this.getCardlessDetails.bind(this);
    }

    componentWillMount() {
        this.getCardlessDetails()
    }

    getCardlessDetails() {
        store.dispatch(getCardlessDetails(this.props.id)).then(
            (response) => {
                const data = response.value.data.payload;
                this.setState({
                    id: data.id != null ? data.id : '-',
                    transactionId: data.transactionId != null ? data.transactionId : '-',
                    source: data.source != null
                        ? this.props.sourceMap.find(entry => entry.value === data.source)?.label || '-'
                        : '-',
                    mid: data.mid != null ? data.mid : '-',
                    amount: data.amount != null ? formatAmount(I18n._locale, data.amount, 2) + euro : '-',
                    authorizationDate: data.authorizationDate != null ? moment(data.authorizationDate).format('DD/MM/YYYY') : '-',
                    authorizationTime: data.authorizationTime != null ? data.authorizationTime : '-',
                    merchantFee: data.merchantFee != null ? formatAmount(I18n._locale, data.merchantFee, 2) + euro : '-',
                    merchantCommissionAmount: data.merchantCommissionAmount != null ? formatAmount(I18n._locale, data.merchantCommissionAmount, 2) + euro : '-',
                    acquirerFee: data.acquirerFee != null ? formatAmount(I18n._locale, data.acquirerFee, 2) + euro : '-',
                    acquirerCommissionAmount: data.acquirerCommissionAmount != null ? formatAmount(I18n._locale, data.acquirerCommissionAmount, 2) + euro : '-',
                    closeBatchDate: data.closeBatchDate != null ? moment(data.closeBatchDate).format('DD/MM/YYYY') : '-',
                    paymentDate: data.paymentDate != null ? moment(data.paymentDate).format('DD/MM/YYYY') : '-',
                    paymentReqDate: data.paymentReqDate != null ? moment(data.paymentReqDate).format('DD/MM/YYYY HH:mm:ss') : '-',
                    paymentRespDate: data.paymentRespDate != null ? moment(data.paymentRespDate).format('DD/MM/YYYY HH:mm:ss') : '-',
                    paymentRespMessage: I18n.t(`pages.cardless.details.statusDescription.${data.paymentRespMessage}`),
                    debitNoteMonth: data.debitNoteMonth != null ? data.debitNoteMonth : '-',
                    debitNoteYear: data.debitNoteYear != null ? data.debitNoteYear : '-',
                    debitNoteNumber: data.debitNoteNumber != null ? data.debitNoteNumber : '-',
                    debitNoteScheme: data.debitNoteScheme != null ? data.debitNoteScheme : '-',
                    inserted: data.inserted != null ? moment(data.inserted).format('DD/MM/YYYY HH:mm:ss') : '-',
                })
            },
            (error) => {
            })
    }

    render() {
        return (
            <React.Fragment>
                <div className="all-details__wrapper">
                    <div className="transaction__details_modal-header--print transaction__details_modal-header">
                        <h4 className="modal-title">
                            <Translate value="pages.cardless.details.title"/>
                        </h4>
                    </div>
                    {/*1 ROW*/}
                    <div className="all-details__detail-row cardless--details_first-row">
                        <div className="all-details__detailColumn">
                            <Translate value="pages.cardless.details.paymentDate"/>
                            <span>{this.state.paymentDate}</span>
                        </div>
                        <div className="all-details__detailColumn">
                            <Translate value="pages.cardless.details.authorizationDate"/>
                            <span>{this.state.authorizationDate}</span>
                        </div>
                        <div className="all-details__detailColumn">
                            <Translate value="pages.cardless.details.authorizationTime"/>
                            <span>{this.state.authorizationTime}</span>
                        </div>
                        <div className="all-details__detailColumn">
                            <Translate value="pages.cardless.details.source"/>
                            <span>{this.state.source}</span>
                        </div>
                        <div className="all-details__detailColumn">
                            <Translate value="pages.cardless.details.amount"/>
                            <span>{this.state.amount}</span>
                        </div>
                    </div>
                    {/*2 ROW*/}
                    <div className="all-details__detail-row cardless--details_second-row">
                        <div className="all-details__detailColumn">
                            <Translate value="pages.cardless.details.paymentRespMessage"/>
                            <span>{this.state.paymentRespMessage}</span>
                        </div>
                        <div className="all-details__detailColumn">
                            <Translate value="pages.cardless.details.mid"/>
                            <span>{this.state.mid}</span>
                        </div>
                        <div className="all-details__detailColumn">
                            <Translate value="pages.cardless.details.trxId"/>
                            <span style={{wordBreak: 'break-word'}}>{this.state.transactionId}</span>
                        </div>
                        <div className="all-details__detailColumn">
                            <Translate value="pages.cardless.details.id"/>
                            <span>{this.state.id}</span>
                        </div>
                        <div className="all-details__detailColumn">
                            <Translate value="pages.cardless.details.closeBatchDate"/>
                            <span>{this.state.closeBatchDate}</span>
                        </div>
                    </div>
                    {/*3 ROW*/}
                    <div className="all-details__detail-row cardless--details_third-row">
                        <div className="all-details__detailColumn">
                            <Translate value="pages.cardless.details.inserted"/>
                            <span>{this.state.inserted}</span>
                        </div>
                        <div className="all-details__detailColumn">
                            <Translate value="pages.cardless.details.merchantFee"/>
                            <span>{this.state.merchantFee}</span>
                        </div>
                        <div className="all-details__detailColumn">
                            <Translate value="pages.cardless.details.merchantCommissionAmount"/>
                            <span>{this.state.merchantCommissionAmount}</span>
                        </div>
                        <div className="all-details__detailColumn">
                        </div>
                        <div className="all-details__detailColumn">
                        </div>
                    </div>
                    {/*4 ROW*/}
                    <div className="all-details__detail-row cardless--details_fourth-row">
                        <div className="all-details__detailColumn">
                            <Translate value="pages.cardless.details.acquirerCommissionAmount"/>
                            <span>{this.state.acquirerCommissionAmount}</span>
                        </div>
                        <div className="all-details__detailColumn">
                            <Translate value="pages.cardless.details.paymentReqDate"/>
                            <span>{this.state.paymentReqDate}</span>
                        </div>
                        <div className="all-details__detailColumn">
                            <Translate value="pages.cardless.details.paymentRespDate"/>
                            <span>{this.state.paymentRespDate}</span>
                        </div>
                        <div className="all-details__detailColumn">
                        </div>
                        <div className="all-details__detailColumn">
                        </div>
                    </div>
                    {/*5 ROW*/}
                    <div className="all-details__detail-row cardless--details_fifth-row">
                        <div className="all-details__detailColumn">
                            <Translate value="pages.cardless.details.debitNoteMonth"/>
                            <span>{this.state.debitNoteMonth}</span>
                        </div>
                        <div className="all-details__detailColumn">
                            <Translate value="pages.cardless.details.debitNoteYear"/>
                            <span>{this.state.debitNoteYear}</span>
                        </div>
                        <div className="all-details__detailColumn">
                            <Translate value="pages.cardless.details.debitNoteNumber"/>
                            <span>{this.state.debitNoteNumber}</span>
                        </div>
                        <div className="all-details__detailColumn">
                            <Translate value="pages.cardless.details.debitNoteScheme"/>
                            <span>{this.state.debitNoteScheme}</span>
                        </div>
                        <div className="all-details__detailColumn">
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}


export default connect(stateMap)(CardlessDetails);
